module.exports = __webpack_public_path__ + "static/media/thumbnail-plaza_felujitas_2.3bc01985.jpg";